import {Component, Input, OnInit, AfterViewInit} from '@angular/core';
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";
import * as feather from "feather-icons";
import {RepairDto} from "../../../auto-generated-server-dtos/claim/repairs/repair-dto";

@Component({
  selector: 'app-submit-modal',
  standalone: true,
    imports: [
        AsyncPipe,
        NgForOf,
        NgIf
    ],
  templateUrl: './submit-modal.component.html',
  styleUrl: './submit-modal.component.scss'
})
export class SubmitModalComponent implements OnInit, AfterViewInit {
  @Input() claimDto!: ClaimDto;
  @Input() Repairs!: RepairDto[];
  isPartiallyPreApproved = false;
  isFullyPreApproved = false;
  isNotPreApproved = false;

  constructor(private router: Router, public activeModal: NgbActiveModal) {
  }

  viewClaim(): void {
    this.activeModal.close();
    this.router.navigate(['/claim', this.claimDto.claimId]).then();
  }

  returnToClaimsList(): void {
    this.activeModal.close();
    this.router.navigate(['/claim-list']).then();
  }

  ngOnInit(): void {
    this.isFullyPreApproved = this.Repairs.every(repair => repair.preApprovalAmount === repair.total) && this.Repairs.some(repair => repair.preApprovalAmount);
    this.isPartiallyPreApproved = !this.isFullyPreApproved && this.Repairs.some(repair => repair.preApprovalAmount);
    this.isNotPreApproved = !this.isPartiallyPreApproved && !this.isFullyPreApproved;
  }

  ngAfterViewInit() {
    feather.replace();
  }
}
